<template>
  <div class="content">
    <div id="taipei" class="widget clock" data-timezone="+8">
      <!-- <div class="shadow"></div> -->
      <div class="hand seconds"></div>
      <div class="hand minutes"></div>
      <div class="hand hours"></div>
      <div class="hand-cap"></div>
    </div>
  </div>
</template>

<script>
/*
  reference from: https://codepen.io/anon/pen/NwLOKq
*/
/* eslint-disable */
class Clock {
  constructor(id) {
    this.timezone = parseInt(document.getElementById(id).dataset.timezone, 10);
    // console.log(this.timezone);

    if (this.isDST(new Date())) {
      this.timezone += 1;
    }

    this.handSeconds = document.querySelector(`#${id} .hand.seconds`);
    this.handMinutes = document.querySelector(`#${id} .hand.minutes`);
    this.handHours = document.querySelector(`#${id} .hand.hours`);

    this.getTime();
    this.cycle();
  }

  isDST(now) {
    const jan = new Date(now.getFullYear(), 0, 1);
    const jul = new Date(now.getFullYear(), 6, 1);
    const dst = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());

    return now.getTimezoneOffset() < dst;
  }

  draw(hours, minutes, seconds) {
    const drawSeconds = ((seconds / 60) * 360) + 90;
    const drawMinutes = ((minutes / 60) * 360) + 90;

    if (hours >= 12) {
      drawHours = hours - 12;
    } else {
      drawHours = hours;
    }
    let drawHours = ((hours / 12) * 360) + 90;

    this.handSeconds.style.transform = `rotate(${drawSeconds}deg)`;
    this.handMinutes.style.transform = `rotate(${drawMinutes}deg)`;
    this.handHours.style.transform = `rotate(${drawHours}deg)`;

    // fix for animation bump on when clock hands hit zero
    if (drawSeconds === 444 || drawSeconds === 90) {
      this.handSeconds.style.transition = 'all 0s ease 0s';
    } else {
      this.handSeconds.style.transition = 'all 0.05s cubic-bezier(0, 0, 0.52, 2.51) 0s';
    }
  }

  getTime() {
    const now = new Date();

    const hours = now.getUTCHours() + this.timezone;
    const minutes = now.getUTCMinutes();
    const seconds = now.getUTCSeconds();

    this.draw(hours, minutes, seconds);
  }

  cycle() {
    setInterval(this.getTime.bind(this), 1000);
  }
}
export default {
  name: 'Clock',
  mounted() {
    const taipei = new Clock('taipei');
  },
};

</script>

<style lang="sass">
$color-primary: #673AB7
$color-secondary: #FFF
$color-tertiary: cadetblue

$size-base: 3px
$size-small: $size-base / 2
$size-large: $size-base * 2

$clock-size: $size-base * 32
$clock-size-small: $size-base * 20
$clock-weight: $size-small
$clock-weight-small: $size-small / 2
$clock-seconds-length: 95%
$clock-minutes-length: 85%
$clock-hours-length: 75%


.content
  display: inline-block
  .widget
    padding: $size-large
    margin: $size-large
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12)
    
    &.clock
      position: relative
      width: $clock-size
      height: $clock-size
      border-radius: 100%
      box-sizing: border-box
      background-color: $color-tertiary
      
      // clock rim
      &:before
        content: ''
        width: 100%
        height: 100%
        position: absolute
        top: 0
        left: 0
        border: $clock-weight solid $color-secondary
        border-radius: 100%
        box-sizing: border-box
      
      // clock shadow
      .shadow
        content: ''
        width: 100%
        height: 500px
        position: absolute
        top: 50%
        left: 0
        background: linear-gradient(to bottom, rgba(0, 0, 0, 0.65) 0%, rgba(0, 0, 0, 0) 100%)
        transform: rotate(-45deg)
        transform-origin: 50% 0%
        opacity: 0.3
        z-index: -1
      
      .hand
        height: $clock-weight
        position: absolute
        top: ($clock-size - $clock-weight) / 2
        background-color: $color-secondary
        border-radius: 100% 0% 0% 100%
        transform-origin: right ($clock-weight / 2)
        transition: all 0.05s cubic-bezier(0, 0, 0.52, 2.51) 0s
        
        &.seconds
          width: 50 - (100 - $clock-seconds-length)
          left: 100 - $clock-seconds-length
          opacity: 0.25
        
        &.minutes
          width: 50 - (100 - $clock-minutes-length)
          left: 100 - $clock-minutes-length
          opacity: 0.5
        
        &.hours
          width: 50 - (100 - $clock-hours-length)
          left: 100 - $clock-hours-length
          opacity: 0.75
      
      .hand-cap
        width: 5%
        height: 5%
        position: absolute
        top: 47.5%
        left: 47.5%
        background-color: $color-secondary
        border-radius: 100%

    label
      display: block
      width: 100%
      position: absolute
      top: -$size-base * 2
      left: 0
      font-family: sans-serif
      font-weight: 200
      font-size: 12px
      text-transform: uppercase
      text-align: center
      letter-spacing: 4px
      color: $color-secondary
      opacity: 0.5
</style>



// WEBPACK FOOTER //
// Clock.vue?3bd80cea